"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  // Options.jsx
  itemsPerPage: '条/页',
  jumpTo: '跳至',
  jumpToConfirm: '确定',
  page: '页',
  // Pagination.jsx
  prevPage: '上一页',
  nextPage: '下一页',
  prev5: '向前 5 页',
  next5: '向后 5 页',
  prev3: '向前 3 页',
  next3: '向后 3 页',
  total: '总计',
  items: '条'
};
exports.default = _default;